export enum CompanyOrIndividualFormNamesEnum {
  FORM_GROUP_NAME = 'CompanyOrIndividual',
}
